import React from 'react';
import Hero from './Hero.js'
import Team from './Team.js'

function AboutPage() {
    return ( 
        <>
        <Hero/>
        <Team/>
            </>
     );
}

export default AboutPage;